import { render, staticRenderFns } from "./FooterDesktop.vue?vue&type=template&id=04156ce6&scoped=true&"
import script from "./FooterDesktop.vue?vue&type=script&lang=js&"
export * from "./FooterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./FooterDesktop.vue?vue&type=style&index=0&id=04156ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04156ce6",
  null
  
)

export default component.exports